import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 bg-surface-section relative border-b border-surface-border" data-id="element-81">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="bg-surface-card border border-gold/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-2xl shadow-gold/5" data-id="element-83">
          {/* Resplandor de fondo */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-64 bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-84"></div>

          <div className="relative z-10 flex flex-col items-center" data-id="element-85">
            <div className="bg-surface-elevated p-4 rounded-full border border-gold/40 mb-6 shadow-lg" data-id="element-86">
              <ShieldCheckIcon className="w-12 h-12 text-gold" data-id="element-87" />
            </div>

            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-88">
              Garantía de Hierro de <span className="text-gold" data-id="element-89">7 Días</span>
            </h2>

            <p className="font-body text-gray-300 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto mb-6" data-id="element-90">
              Prueba{' '}
              <span className="text-white font-bold italic" data-id="element-91">
                Carisma al Instante
              </span>{' '}
              por 7 días completos. Lee el manual, aplica los trucos y observa
              cómo cambia la forma en que los demás te perciben.
            </p>

            <p className="font-body text-gray-400 text-base md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-92">
              Si por alguna razón sientes que esto no es para ti, o no ves
              resultados reales en tus interacciones, envíanos un correo y te
              devolveremos el{' '}
              <span className="text-gold font-bold" data-id="element-93">100% de tu dinero</span>.
              Sin preguntas, sin letras pequeñas. Todo el riesgo lo asumimos
              nosotros.
            </p>
          </div>
        </div>
      </div>
    </section>;
}